module.exports = __webpack_public_path__ + "static/media/车规级芯片录屏_x264.44ed8eb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/车规级芯片录屏_x264.mp4
// module id = llDK
// module chunks = 13